import {ChangeDetectionStrategy, Component, ViewChild} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {CONFIG} from "../../../app/config";
import {TAction, TAddressTipo, TZiptipo} from "../../../app/enum";

import {DataService} from "../../../providers/data-service";
import {LogadoService} from "../../../providers/logado-service";
import {ProfileService} from '../../../providers/profile-service';

import {ProfileRepository} from "../../../repositories/profile-repository";
import {ListingMenuPage} from "../listing-menu/listing-menu";
import {WebstorService} from "../../../providers/webstor-service";

@Component({
    selector: 'page-address-menu',
    templateUrl: 'address-menu.html',
    providers: [ProfileRepository, ProfileService, WebstorService],
    changeDetection: ChangeDetectionStrategy.Default
})
export class AddressMenuPage {

    @ViewChild('inputAddressNome') inputAddressNome: any;
    @ViewChild('inputAddressLote') inputAddressLote: any;

    inputSelected: any;

    config: any;
    logado: any;

    etapa: number;
    indexAD: number;
    rootile: any;
    copyile: any;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public util: Util, public logadoService: LogadoService,
                public viewCtrl: ViewController, public dataService: DataService,
                public profileService: ProfileService, public profileRepository: ProfileRepository,
                public webstorService: WebstorService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.indexAD = this.navParams.get('indexAD');
        this.rootile = this.navParams.get('rootile');
        this.copyile = this.util.deepCopy(this.rootile);

        this.prepareLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    prepareLoad() {

        /* Google Analytics */
        if (this.etapa == 0) this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Address', '/address-list');
        if (this.etapa == 1) this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Address', '/address-info');

        //Address New
        if (!this.copyile.Addresss.length) {
            let address = {AddressID: 0, AddressCode: '', AddressVila: '', AddressNome: '', AddressLote: '', AddressTipo: TAddressTipo.adSede, AddressTown: '', AddressRook: '', AddressApto: '', AddressMore: '', Zipcity: null};
            this.copyile.Addresss.push(address);
        }

    }

    getTitle() {

        return 'Endereço';

    }

    addressErro(alert): boolean {

        // Field Force
        let vazio = '';

        // etapa = 2 Endereço
        let address = this.copyile.Addresss[this.indexAD];
        if (!vazio && !this.util.jsTrim(address, ['AddressCode'])) vazio = 'Seu cep';
        if (!vazio && !this.util.jsTrim(address, ['AddressNome'])) vazio = 'Seu endereço';
        if (!vazio && !this.util.jsTrim(address, ['AddressVila'])) vazio = 'Seu bairro';
        if (!vazio && !this.util.jsTrim(address, ['AddressLote'])) vazio = 'Número do endereço';
        if (!vazio && !this.util.jsTrim(address, ['Zipcity', 'ZipcityNome'])) vazio = 'Sua cidade';

        // Field verify
        if (vazio && alert) this.util.alertSimply(vazio, 'Obrigatório Informar');

        return !!vazio;

    }

    addressSave(acLixo: boolean = false) {

        if (this.addressErro(true)) return;

        let address = this.copyile.Addresss[this.indexAD];

        let onSave = (codigo) => {
            if (codigo) address.AddressID = codigo;
            if (acLixo) {
                this.copyile.Addresss.splice(this.indexAD, 1);
                this.rootile.Addresss.splice(this.indexAD, 1);
            }
            this.util.populateObj(this.rootile, this.copyile);
            this.dismiss();
        };

        let loading = this.util.loadingDots();
        loading.present();

        let action = (acLixo ? TAction.acLixo : TAction.acSave);
        this.profileService.address(action, address.AddressID, this.copyile.Profile.ProfileID, address)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onSave(data.Codigo),
                erro => this.util.alertPopula(erro, this.rootile, this.copyile)
            );

    }

    zipcodeFind(event) {

        let code = event.target.value;
        if (code.length != 10) return;

        let onCity = (city) => {
            if (!city || !city.Ziploads || !city.Ziploads[0]) return;
            let focus: any = this.inputAddressNome;

            this.copyile.Addresss[this.indexAD].Zipcity = {};
            this.copyile.Addresss[this.indexAD].Zipcity.ZipcityID   = city.Ziploads[0].Pkey;
            this.copyile.Addresss[this.indexAD].Zipcity.ZipcityZone = city.Ziploads[0].Zone;
            this.copyile.Addresss[this.indexAD].Zipcity.ZipcityNome = city.Ziploads[0].City;

            this.copyile.Addresss[this.indexAD].AddressNome = city.Ziploads[0].Nome;
            this.copyile.Addresss[this.indexAD].AddressVila = city.Ziploads[0].Vila;

            focus = this.inputAddressLote;
            setTimeout(() => focus.setFocus(), 500);
        };

        let loading = this.util.loadingDots('Pesquisando endereço...');
        loading.present();

        this.webstorService.zipload(TAction.acLoad, TZiptipo.zpCode, code)
            .finally(() => loading.dismiss()).subscribe(
                data => onCity(data),
                erro => this.util.alertResult(erro)
        );

    }

    zipcityMenu(event) {

        let onCity = (ziploads) => {

            this.profileRepository.zipcity(ListingMenuPage, ziploads, {ev: event}).subscribe(
                data => {
                    if (!data) return;
                    this.copyile.Addresss[this.indexAD].Zipcity = {};
                    this.copyile.Addresss[this.indexAD].Zipcity.ZipcityID   = data.Pkey;
                    this.copyile.Addresss[this.indexAD].Zipcity.ZipcityZone = data.Zone;
                    this.copyile.Addresss[this.indexAD].Zipcity.ZipcityNome = data.City;
                });

        };

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.zipload(TAction.acLoad, TZiptipo.zpCity)
            .finally(() => loading.dismiss()).subscribe(data => onCity(data.Ziploads));

    }

    dismiss() {

        let address = this.copyile.Addresss[this.indexAD];
        let addressNovo = !address.AddressID;
        let addressLixo = this.addressErro(false);
        let profileNovo = !this.copyile.Profile.ProfileID;

        if (!addressLixo && profileNovo) {
            this.util.populateObj(this.rootile, this.copyile);
        }

        if (addressNovo && (!profileNovo || addressLixo)) {
            this.copyile.Addresss.splice(this.indexAD, 1);
            this.rootile.Addresss.splice(this.indexAD, 1);
            this.util.populateObj(this.copyile, this.rootile);
        }

        if (this.viewCtrl.isOverlay) this.viewCtrl.dismiss();
        else this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/address-menu/address-menu.ts